export default class Product_Keikakumeisai
{
    constructor (data = null)
    {
        if (data !== null)
        {
            // data will be an excel row from the Keikakumeisai sheet
            this.RegisteredData = this.IsDataRegistered(data.getCell(4));
            this.Zaiko = this.GetCellInteger(data.getCell(3));
            this.SellDate = new Date(data.getCell(4).value);
            this.Factory = data.getCell(5).value?.toString().trim();
            this.ProductName = data.getCell(6).value?.toString().trim();
            this.Hanbaisaki = data.getCell(7).value?.toString().trim();
            this.Amount = this.GetCellInteger(data.getCell(8));
            this.Price = this.GetCellFloat(data.getCell(9));
            this.RetailPrice = this.GetCellFloat(data.getCell(10));
            this.Sales = this.GetCellInteger(data.getCell(11));
            this.GrossOperatingProfit = this.GetCellInteger(data.getCell(12));
            this.PurchaseAmount = this.GetCellInteger(data.getCell(13));
            this.SamplePurchaseAmount = this.GetCellInteger(data.getCell(14));
            this.PrototypeCost = this.GetCellInteger(data.getCell(15));
            this.WAX = this.GetCellInteger(data.getCell(16));
            this.MoldCost = this.GetCellInteger(data.getCell(17));
            this.CopyrightFees = this.GetCellInteger(data.getCell(18));
            this.Customs = this.GetCellInteger(data.getCell(19));
            this.PackageDesign = this.GetCellInteger(data.getCell(20));
            this.Commission_Sculptor = this.GetCellInteger(data.getCell(21));
            this.Commission_PB = this.GetCellInteger(data.getCell(22));
            this.Commission_Alan = this.GetCellInteger(data.getCell(23));
            this.Commission_Production = this.GetCellInteger(data.getCell(24));
            this.Fee_IT_PB_EC = this.GetCellInteger(data.getCell(25));
            this.Fee_CardPayment = this.GetCellInteger(data.getCell(26));
            this.Shipping_Warehouse = this.GetCellInteger(data.getCell(27));
            this.Shipping_PB = this.GetCellInteger(data.getCell(28));
            this.Handling_Warehouse = this.GetCellInteger(data.getCell(29));
            this.Handling_PB = this.GetCellInteger(data.getCell(30));
            this.ShippingCase = this.GetCellInteger(data.getCell(31));
            this.ShippingExpenses = this.GetCellInteger(data.getCell(32));
            this.Devanning = this.GetCellInteger(data.getCell(33));
            this.Fee_Storage = this.GetCellInteger(data.getCell(34));
            this.HeadOfficeExpenses = this.GetCellInteger(data.getCell(35));
            this.TotalCost = this.GetCellInteger(data.getCell(36));
            this.Profit = this.GetCellInteger(data.getCell(37));
            this.ProfitMargin = this.GetCellFloat(data.getCell(38));
            this.NonCostExpenses = this.GetCellInteger(data.getCell(40));
            this.MoldCostSalesRatio = this.GetCellFloat(data.getCell(41));
            this.PurchasePrice = this.GetCellInteger(data.getCell(42));
            this.CostPerPiece = this.GetCellInteger(data.getCell(43));
            this.NumberOfSamples = this.GetCellInteger(data.getCell(44));
            this.SampleCost = this.GetCellInteger(data.getCell(45));
            this.Subordinates = this.GetCellInteger(data.getCell(47));
            this.ProfitMarginPerItem = this.GetCellFloat(data.getCell(48));
            this.Series = data.getCell(49).value?.toString().trim();
            this.NumberOfReturns = this.GetCellInteger(data.getCell(50));
            this.ReplacementCost = this.GetCellInteger(data.getCell(51));
            this.Brand = data.getCell(52).value?.toString().trim();
            this.XPHK_Management = this.GetCellInteger(data.getCell(53));
            this.SampleProduction_Management = this.GetCellInteger(data.getCell(54));
            this.ExchangeRate_USD_Buy = this.GetCellFloat(data.getCell(56));
            this.ExchangeRate_USD_Sell = this.GetCellFloat(data.getCell(57));
            // productCode in DB
            this.StyleNumber = data.getCell(58).value?.toString().trim();
            this.JAN = data.getCell(59).value?.toString().trim();
            this.MoldSerialNumber = data.getCell(65).value?.toString().trim();
        }
    }

    IsDataRegistered(cell)
    {
        return cell.fill.pattern !== 'none';
    }

    GetCellInteger(cell)
    {
        if (cell.value === null || cell.value === undefined)
        {
            return null;
        }

        return Math.round(cell.formula ? cell.result : parseFloat(cell.value));
    }

    GetCellFloat(cell)
    {
        if (cell.value === null || cell.value === undefined)
        {
            return null;
        }
            
        return cell.formula ? cell.result : parseFloat(cell.value);
    }
}